import { ManifestApiResponse } from '@manifest-cyber/types/interface/apiResponse';
import { rejectFailedRequestOrEmptyData } from '../../lib/request/rejectFailedRequest/rejectFailedRequest';
import {
  CompositePermissionUrn,
  PermissionUrn,
} from '../../pages/UserSettings/Roles/api/permissions.type';
import { UserApiResponse } from '../../types/FullInterfaces';
import { AxiosProxy } from '../axiosProxy/axiosProxy';
import { MappedUser, mapUser } from './user.mapper';

const getUser = async (): Promise<MappedUser> => {
  const response: UserApiResponse = await AxiosProxy.get({ url: 'user/self' });

  const successfulResponse = await rejectFailedRequestOrEmptyData(response);
  const user = successfulResponse.data;

  if (!user) {
    throw new Error('No user found');
  }

  return mapUser(user);
};

export interface UserPermissionsResponse {
  permissions: PermissionUrn[];
  roles: {
    id: string;
    name: string;
    urn: CompositePermissionUrn;
    permissions: string[];
  }[];
}

const getUserPermissions = async (): Promise<UserPermissionsResponse> => {
  const response: ManifestApiResponse<UserPermissionsResponse> = await AxiosProxy.get({
    url: 'user/self/permissions',
  });

  const successfulResponse = await rejectFailedRequestOrEmptyData(response);

  return successfulResponse.data;
};

export const UserApi = {
  getUser,
  getUserPermissions,
};
